/**
 * Rutas de fiscal — fiscal: impuestos, VeriFACTU, TicketBAI y configuración fiscal.
 *
 * Se componen en `src/pages/index.jsx`. Es un fragmento, no un array: React Router
 * recorre los `<React.Fragment>` hijos de `<Routes>`, así que el JSX se mudó tal cual
 * —sin `key` ni comas— y el diff es el movimiento, nada más.
 *
 * `routeTable.test.jsx` congela las 174 rutas de la app contra la tabla previa a la
 * mudanza: perder una ruta aquí no da error, da un 404.
 */
import { Route, Navigate } from 'react-router-dom';
import { lazyWithRetry } from '@/lib/lazyWithRetry';
import { PermissionGuard } from '@/components/auth/PermissionGuard';
import { PERMS } from '@/constants/permissions';

const ImpuestosHub = lazyWithRetry(() => import("@/pages/ImpuestosHub"));
const TaxFilingDetail = lazyWithRetry(() => import("@/pages/TaxFilingDetail"));
const ConfiguracionFiscal = lazyWithRetry(() => import("@/pages/ConfiguracionFiscal"));
const DeclaracionResponsable = lazyWithRetry(() => import("@/pages/DeclaracionResponsable"));

export const routes = (
  <>
                {/* Impuestos fusion (PR4-bis #10) — /impuestos hosts the
                    Hub: Modelos AEAT (legacy Impuestos page) + Centro AEAT
                    (legacy AEATHub) as tabs. /aeat-hub redirects to ?tab=aeat
                    so bookmarks keep working. */}
                {/* Fiscal: backend gatea las lecturas core de tax-filings con fiscal.view. */}
                <Route path="/impuestos" element={<PermissionGuard permission={PERMS.FISCAL_VIEW} fallback={<Navigate to="/" replace />}><ImpuestosHub /></PermissionGuard>} />

                <Route path="/impuestos/:model/:year/:period" element={<PermissionGuard permission={PERMS.FISCAL_VIEW} fallback={<Navigate to="/" replace />}><TaxFilingDetail /></PermissionGuard>} />


                {/* Compliance & Fiscal — VeriFactu and TicketBAIStatus
                    are now tabs inside FacturasHub. Old paths redirect so
                    bookmarks and AI-generated deep-links stay valid. */}
                <Route path="/veri-factu" element={<Navigate to="/facturas?tab=verifactu" replace />} />

                {/* Alias sin guión: createPageUrl('VeriFactu')='/veri-factu', pero
                    enlaces/bookmarks/deep-links escriben '/verifactu'. Sin este
                    redirect caían al catch-all (NotFound) → VeriFactu parecía no
                    disponible. Disponible para TODA cuenta (el tab no tiene gate). */}
                <Route path="/verifactu" element={<Navigate to="/facturas?tab=verifactu" replace />} />

                <Route path="/ticket-bai-status" element={<Navigate to="/facturas?tab=ticketbai" replace />} />

                {/* AEATHub fused into ImpuestosHub as the "Centro AEAT" tab
                    (PR4-bis #10). Permission gating moved inside the tab. */}
                <Route path="/aeat-hub" element={<Navigate to="/impuestos?tab=aeat" replace />} />

                {/* TicketBAIConfig fusionada en el hub ConfiguracionFiscal como
                    tab "ticketbai". Path legacy preservado como redirect. */}
                <Route path="/ticket-bai-config" element={<Navigate to="/configuracion-fiscal?tab=ticketbai" replace />} />

                <Route path="/configuracion-fiscal" element={<PermissionGuard permission={PERMS.FISCAL_VIEW} fallback={<Navigate to="/" replace />}><ConfiguracionFiscal /></PermissionGuard>} />

                {/* Declaración responsable — SIN PermissionGuard, y es el motivo de
                    que esta ruta exista. El art. 13.2 RRSIF pide que conste «de modo
                    visible en el propio sistema informático» sin condicionarlo a rol,
                    y la única superficie que la mostraba (la pestaña de VeriFACTU)
                    vive en `/facturas`, detrás de INVOICING_VIEW. Ponerle un guard
                    aquí reproduciría el hueco que viene a tapar.

                    No expone ni un dato de la empresa: la declaración es del PRODUCTO
                    y su endpoint tampoco lleva company_id. */}
                <Route path="/declaracion-responsable" element={<DeclaracionResponsable />} />
  </>
);
